import React, { useEffect, useState } from "react";
import { Card, Button, Input, message } from "antd";
import {
    Wallet,
    Coins,
    ShieldCheck,
    Lock,
    Sparkles,
    Gift,
} from "lucide-react";
import { toast } from "react-toastify";
import { load } from "@cashfreepayments/cashfree-js";
import reapi from "../apis/reapi";
import { useNavigate } from "react-router-dom";



const quickAmounts = [100, 300, 500, 1000];

export default function BuyCredits() {

    const token = localStorage.getItem('token')

    const navigate = useNavigate()

    const [orderid, setorderid] = useState()


    const [userInfo, setUserInfo] = useState(
        JSON.parse(localStorage.getItem("userInfo"))
    );

    useEffect(() => {
        const updateUser = () => {
            setUserInfo(
                JSON.parse(localStorage.getItem("userInfo"))
            );
        };

        window.addEventListener("userUpdated", updateUser);

        return () => {
            window.removeEventListener("userUpdated", updateUser);
        };
    }, []);

    const [amount, setAmount] = useState(500);
    const [loading, setLoading] = useState(false);


    const getsessionid = async () => {
        let mnewobj = { price: amount, name: userInfo?.name, email: userInfo?.email, mobile: userInfo?.mobile }
        let res = await reapi.post(`/createcashfreeorder`, mnewobj, {
            headers: {
                "Authorization": `Beaer ${token}`
            }
        })

        if (res.data && res.data.payment_session_id) {
            console.log(res.data)
            sessionStorage.setItem('orderid', res.data.order_id)

            setorderid(res.data.order_id)
            return res.data.payment_session_id
        }
    }

    const verifypayment = async (orderids) => {

        try {



            let orderid = sessionStorage.getItem("orderid");

            let res = await reapi.post(`/verifypaymentcashfree`, { orderid }, {
                headers: {
                    "Authorization": `Beaer ${token}`
                }
            })


            if (res.data && res.data.status) {
                console.log(res.data)
                navigate("/payment-success", {
                    state: {
                        creditsAdded: res?.data?.data?.newPGHistory?.amount,
                        currentBalance: res?.data?.data?.user?.wallet,
                        status: res?.data?.data?.newPGHistory?.gatewaydata?.payment_status
                    },
                });

                localStorage.setItem('userInfo', JSON.stringify(res.data.data?.user));
                window.dispatchEvent(new Event("userUpdated"));
                // navigate(`/agency/paymentdone`, { state: { status: 'SUCCESS' } })
                toast.success(res.data.msg)
                // setorderid(res.data.order_id)
                // return res.data.payment_session_id
            } else {
                // navigate(`/agency/paymentdone`, { state: { status: 'FAILED' } })
                console.log('payment falied')
                toast.error(res.data.message)


            }
        } catch (error) {
            // console.log(error.response?.data?.message);
            // console.log(error?.message)
            toast.error(error.response?.data?.message)

        }

    }




    const handleBuyCredits = async () => {
        if (!amount || Number(amount) < 50) {
            toast.warning("Minimum amount is ₹50");
            return;
        }

        try {
            setLoading(true);

            //for cashfree payment


            let cashfree

            let insitialzeSDK = async function () {
                cashfree = await load({
                    mode: 'production'
                })
            }

            insitialzeSDK()

            let sessionid = await getsessionid()
            let checkoutoptions = {
                paymentSessionId: sessionid,
                redirectTarget: "_modal",
            }

            cashfree.checkout(checkoutoptions).then((res) => {
                console.log("pay initiate", res)
                console.log('orderid', orderid)
                verifypayment(orderid)
            })





            // setHistory(res.data?.data?.data || []);
            // setstats(res.data?.data?.stats)
            // setTotalRecords(res.data?.data?.total)
        } catch (error) {
            message.error("Failed to load history");
        } finally {
            setLoading(false);
        }



        console.log("Pay amount:", amount);

        // yaha SabPaisa / payment API call karna
    };

    return (
        <div className="w-full min-h-screen bg-[#f8f9ff] p-4 md:p-6 text-slate-900">



            <div className="max-w-[1400px] mx-auto">
                <div className="mb-7">
                    <h1 className="text-3xl font-extrabold m-0">Buy Credits</h1>
                    <p className="text-slate-600 mt-2">
                        Add credits to optimize more images and reduce Meesho shipping charges.
                    </p>
                </div>

                <div className="rounded-2xl border border-purple-100 bg-gradient-to-r from-purple-50 via-white to-purple-50 p-7 mb-7 flex items-center justify-between">
                    <div className="flex items-center gap-5">
                        <div className="w-20 h-20 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center">
                            <Wallet size={40} />
                        </div>

                        <div>
                            <p className="font-semibold m-0">Available Credits</p>
                            <h2 className="text-3xl font-extrabold m-0">
                                <span className="text-purple-600">{userInfo?.wallet}</span> Credits
                            </h2>
                        </div>
                    </div>

                    <div className="hidden md:flex justify-end">
                        <img
                            src="https://i.ibb.co/zWBLgbV6/Chat-GPT-Image-Jun-13-2026-02-33-32-PM.png"
                            alt="Credits Wallet"
                            className="w-[200px] object-contain"
                        />
                    </div>
                </div>

                <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,1fr)_520px] gap-6">
                    <Card className="rounded-2xl shadow-sm">
                        <h2 className="text-2xl font-extrabold m-0">Add Credits</h2>
                        <p className="text-slate-600 mt-2">
                            Enter any amount to add credits to your account.
                        </p>

                        <div className="mt-7">
                            <label className="font-bold">Enter Amount (₹)</label>

                            <Input
                                value={amount}
                                onChange={(e) => setAmount(e.target.value.replace(/\D/g, ""))}
                                prefix={<span className="text-2xl font-bold">₹</span>}
                                className="mt-3 h-16 text-3xl font-extrabold rounded-xl"
                            />

                            <p className="mt-2 text-slate-700">Minimum amount is ₹50</p>
                        </div>

                        <div className="mt-6 bg-purple-50 rounded-2xl p-6 flex items-center justify-between">
                            <div className="flex items-center gap-5">
                                <div className="w-16 h-16 rounded-full bg-green-100 text-green-600 flex items-center justify-center">
                                    <Coins size={36} />
                                </div>

                                <div>
                                    <p className="font-bold m-0">You Will Get</p>
                                    <h2 className="text-3xl font-extrabold m-0">
                                        <span className="text-green-600">{amount || 0}</span>{" "}
                                        Credits
                                    </h2>
                                </div>
                            </div>

                            <div className="bg-green-100 text-green-700 px-4 py-2 rounded-xl font-semibold">
                                1 Credit = ₹1
                            </div>
                        </div>

                        <div className="mt-8">
                            <h3 className="font-bold mb-4">Quick Amount</h3>

                            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                                {quickAmounts.map((item) => (
                                    <button
                                        key={item}
                                        onClick={() => setAmount(item)}
                                        className={`h-14 rounded-xl border font-bold text-lg transition ${Number(amount) === item
                                            ? "border-purple-600 bg-purple-50 text-purple-700"
                                            : "border-slate-200 bg-white hover:border-purple-400"
                                            }`}
                                    >
                                        ₹{item}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <Button
                            type="primary"
                            size="large"
                            className="mt-6 w-full h-14 bg-purple-600 text-lg font-bold rounded-xl"
                            icon={<Lock size={20} />}
                            onClick={handleBuyCredits}
                        >
                            Buy Credits Securely
                        </Button>

                        <p className="text-center text-slate-500 mt-5">
                            <ShieldCheck size={18} className="inline mr-2" />
                            Secure payments powered by Cashfree
                        </p>
                        <p className="text-center text-slate-500">
                            <ShieldCheck size={18} className="inline mr-2" />
                            ShipLess AI is operated by GWALAX ONLINE SERVICES.
                        </p>
                    </Card>

                    <div className="space-y-6">
                        <Card className="rounded-2xl shadow-sm">
                            <h2 className="text-xl font-extrabold mb-6">
                                How Credits Work
                            </h2>

                            <InfoRow
                                icon={<Sparkles />}
                                title="1 Credit = ₹1"
                                desc="Simple and transparent pricing."
                            />

                            <InfoRow
                                icon={<Sparkles />}
                                title="Credits are used for optimization"
                                desc="Each image optimization costs 10 credits."
                            />

                            <InfoRow
                                icon={<Gift />}
                                title="No Expiry"
                                desc="Your credits never expire."
                            />

                            <InfoRow
                                icon={<ShieldCheck />}
                                title="Secure & Safe"
                                desc="Your payments are 100% secure."
                            />
                        </Card>

                        <Card className="rounded-2xl shadow-sm">
                            <h2 className="text-xl font-extrabold">Payment Methods</h2>
                            <p className="text-slate-600">
                                All payments are secure and encrypted.
                            </p>

                            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-5">
                                {["UPI", "VISA", "Mastercard", "Net Banking"].map((item) => (
                                    <div
                                        key={item}
                                        className="h-12 border rounded-lg flex items-center justify-center font-bold bg-white"
                                    >
                                        {item}
                                    </div>
                                ))}
                            </div>

                            <div className="mt-6 space-y-3">
                                {[
                                    "100% Secure Payments",
                                    "Instant Credit Activation",
                                    "Trusted by Thousands of Sellers",
                                    "24x7 Support",
                                ].map((text) => (
                                    <div key={text} className="flex items-center gap-3">
                                        <span className="text-green-600 font-bold">✓</span>
                                        <span>{text}</span>
                                    </div>
                                ))}
                            </div>
                        </Card>
                    </div>
                </div>

                <p className="text-center text-slate-600 mt-7">
                    <Lock size={16} className="inline mr-2" />
                    Your payment information is secure and encrypted
                </p>
            </div>
        </div>
    );
}

function InfoRow({ icon, title, desc }) {
    return (
        <div className="flex gap-4 mb-7 last:mb-0">
            <div className="w-12 h-12 rounded-xl bg-purple-50 text-purple-600 flex items-center justify-center shrink-0">
                {icon}
            </div>

            <div>
                <h3 className="font-bold m-0">{title}</h3>
                <p className="text-slate-500 m-0 mt-1">{desc}</p>
            </div>
        </div>
    );
}